// extracted by mini-css-extract-plugin
export var askAiIcon = "_ox-k";
export var category = "_ox-a";
export var categoryHeader = "_ox-f";
export var container = "_ox-0";
export var group = "_ox-b";
export var groupItems = "_ox-g";
export var groupSeparator = "_ox-l";
export var highlight = "_ox-8";
export var loading = "_ox-1";
export var noResults = "_ox-3";
export var placeholder = "_ox-2";
export var resultContent = "_ox-5";
export var resultIcon = "_ox-d";
export var resultItem = "_ox-h";
export var resultMeta = "_ox-9";
export var resultSubtitle = "_ox-7";
export var resultSuffix = "_ox-j";
export var resultTitle = "_ox-6";
export var resultsList = "_ox-4";
export var searchGroup = "_ox-e";
export var selected = "_ox-i";
export var subgroup = "_ox-c";